export const SHARED_REACT_QUERY_CONFIG = {
  // staleTime: 5000,
  // cacheTime: 30000,
};
